// TEAMS Website - Main Entry Point
// Application bootstrap and initialization

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/main.scss';

// Get the root element
const rootElement = document.getElementById('root');

// Create React root
const root = ReactDOM.createRoot(rootElement);

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
